import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    const userEmail = (formData.get('email') as string || '').trim();

    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      return;
    }

    if (!userEmail) {
      setStatus('error');
      setMessage('请输入邮箱地址');
      return;
    }

    setStatus('loading');

    try {
      const body = new URLSearchParams();
      body.append('email', userEmail);

      const response = await fetch('https://readdy.ai/api/form/d9qsek7nahb7382ovepg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败';
        setStatus('error');
        setMessage(serverMsg.includes('spam') || serverMsg.includes('form data is spam')
          ? '订阅失败，请稍后再试'
          : serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试');
    }
  };

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-background-900 via-background-800 to-background-900 p-8 md:p-12">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-primary-500 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-accent-500 blur-3xl"></div>
          </div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 font-heading">
                不想错过任何爆料？
              </h2>
              <p className="text-background-300 text-sm md:text-base">
                订阅我们的推送，第一时间获取最新黑料资讯
              </p>
            </div>
            <form
              onSubmit={handleSubmit}
              data-readdy-form="true"
              className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto"
            >
              <div className="honeypot-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                required
                className="px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder:text-background-400 focus:outline-none focus:border-primary-400 w-full lg:w-72 text-sm"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors duration-200 disabled:opacity-50 whitespace-nowrap cursor-pointer text-sm"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
              </button>
            </form>
          </div>
          {(status === 'success' || status === 'error') && (
            <div className={`relative z-10 mt-4 text-center text-sm ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
              {message}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}